<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<div class="columns column6">
				<h2 v-if="page.subtitle" class="subtitle">
					{{ page.subtitle }}
				</h2>
				<h1>{{ page.title || page.header }}</h1>
				<div v-parse-links v-html="page.content" />
			</div>
			<div class="columns column6">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.044233008176!2d4.882330876986668!3d52.40587454467245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6093a7a8efd35%3A0x90c5a94a76ba3e0!2sHelling%207!5e0!3m2!1snl!2snl!4v1682339085955!5m2!1snl!2snl"
					width="100%"
					height="550"
					style="border: 0"
					allowfullscreen
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				/>
			</div>
		</main-content>

		<!--
		<section class="content-section section-reservations">
			<div class="row">
				<div class="columns column6">
					<h3>{{ defaults[locale].website.restaurantName }}</h3>
					<div class="address">
						<p>
							<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
							><br />
							<span>{{ defaults[locale].website.country }}</span
							><br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>{{ defaults[locale].website.phone }}</span> </a
							><br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>{{ defaults[locale].website.email }}</span>
							</a>
						</p>
					</div>
				</div>
				<div class="columns column6">
					<div class="form-wrapper">
						<h3>{{ defaults[locale].website.contactFormHeader }}</h3>
						<contact-form name="contact" :form="form" />
					</div>
				</div>
			</div>
		</section>-->

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
onMounted(() => {
	if (window.FT) {
		window.FT.widgets.current.parse();
	}
});

// const { data: form } = await useWebsiteFetch('contact', {
// 	query: { language: locale.value },
// 	key: `${locale.value}/contact`,
// });
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
}

.form-wrapper {
	padding: 40px 30px;
	background: #091427;

	h3 {
		color: #fff !important;
	}
}
</style>
